import { h, Component, createRef } from 'preact';
import cx from 'classnames';
import debounce from 'lodash-es/debounce';

import { User } from '../../../../types';
import { ListingService } from '../../../utils/listing.service';

interface ListingUploadForFieldProps {
  onUserSelect?: (user: User) => any
}

interface ListingUploadForFieldState {
  selectionMode?: boolean;
  searchResultsVisible?: boolean;

  searchText?: string;
  searchResults?: User[];
  selectedUser?: User;
}

export class ListingUploadForField extends Component<ListingUploadForFieldProps, ListingUploadForFieldState> {
  listingService = new ListingService();

  constructor(props) {
    super(props);

    this.state = {
      selectionMode: false,
      searchResults: [],
      searchText: ''
    };
  }

  async runUserSearch(search: string) {
    const response = await this.listingService.getOtherUserUploadChoices(search, { page_size: 10 });
    this.setState({ searchResults: response.data.results });
  }

  async onSearchInputChange(event) {
    const searchText = event.target.value;
    this.setState({ searchText });

    try {
      await this.runUserSearch(searchText);
    } catch (ex) {
      console.error(ex);
    }
  }

  onSearchInputFocus() {
    this.setState({ searchResultsVisible: true });
    this.runUserSearch(this.state.searchText);
  }

  onSearchCancel() {
    this.setState({
      searchResultsVisible: false,
      selectionMode: false
    });
  }

  onReset() {
    this.setState({ selectedUser: null });

    if (this.props.onUserSelect) {
      this.props.onUserSelect(null);
    }
  }

  getStatusViewButtons(props, state: ListingUploadForFieldState) {
    if (!state.selectedUser) {
      return (
        <div className="my-2">
          <button type="button" className="btn btn-outline-dark"
            onClick={ () => this.setState({ selectionMode: true }) }>
            Select other user
          </button>
        </div>
      );
    } else {
      return (
        <div className="d-flex my-2">
          <button type="button" className="btn btn-outline-dark"
            onClick={ () => this.setState({ selectionMode: true }) }>
            Select another user
          </button>

          <button type="button" className="btn btn-outline-dark ml-2"
            onClick={ () => this.onReset() }>
            Upload to my account
          </button>
        </div>
      );
    }
  }

  getStatusView(props: ListingUploadForFieldProps, state: ListingUploadForFieldState) {
    let textSnippet;
    if (!state.selectedUser) {
      textSnippet = (
        <span>
          This listing will be uploaded to&nbsp;
          <strong>your own account</strong>.
        </span>
      );
    } else {
      textSnippet = (
        <span>
          This listing will be uploaded to&nbsp;
          <strong>{ state.selectedUser.fullName }</strong>'s 
          account.
        </span>
      );
    }

    return (
      <div className="d-flex flex-column">
        { textSnippet }

        { this.getStatusViewButtons(props, state) }
      </div>
    );
  }

  onResultClick(user: User) {
    this.setState({
      searchResultsVisible: false,
      searchText: '',
      selectedUser: user,
      selectionMode: false
    });

    if (this.props.onUserSelect) {
      this.props.onUserSelect(user);
    }
  }

  createSuggestionItem(user: User) {
    return (
      <p onClick={ () => this.onResultClick(user) }>
        { user.fullName }
      </p>
    );
  }

  getUserSelectView(props: ListingUploadForFieldProps, state: ListingUploadForFieldState) {
    return (
      <div className="form-group flex-fill position-relative">
        {/*
          position-relative here makes the search result width match us
          as expected
        */}
        <label className="font-weight-bold">
          Which user should this property be uploaded with?
        </label>
        <div className="d-flex">
          <input type="text" className="form-control flex-fill mr-2"
            onInput={ debounce(event => this.onSearchInputChange(event), 500) }
            onFocus={ event => this.onSearchInputFocus() }
            placeholder="Enter a name to search for" />
          <button type="button" className="btn btn-outline-dark"
            onClick={ () => this.onSearchCancel() }>
            Cancel
          </button>
        </div>
        <div className={ cx('hi-location-search-box__results', {
          active: state.searchResultsVisible
        }) }>
          { state.searchResults.map(result => this.createSuggestionItem(result)) }
        </div>
      </div>
    )
  }

  render(props: ListingUploadForFieldProps, state: ListingUploadForFieldState) {
    if (state.selectionMode) {
      return this.getUserSelectView(props, state);
    } else {
      return this.getStatusView(props, state);
    }
  }
}
